import { getType } from 'typesafe-actions';
import { setCurrentLanguage } from '../actions/currentLanguage.actions';

import { RootAction } from '../actions/types';
import { CurrentLanguageState } from './types';
import {
  LANGUAGE_ENGLISH,
  LANGUAGE_SPANISH,
  LANGUAGE_PORTUGUESE,
  LOCALE_EN_US,
  LOCALE_ES_MX,
  LOCALE_PT_BR,
} from '../../constants';

const initialState: CurrentLanguageState = LANGUAGE_ENGLISH;

// Sanitize language code to handle legacy locale values from persisted state
const sanitizeLanguage = (language: string): CurrentLanguageState => {
  // Handle legacy 'en-US' or new 'en'
  if (language === LOCALE_EN_US || language === LANGUAGE_ENGLISH) return LANGUAGE_ENGLISH;

  // Handle legacy 'es-MX' or new 'es'
  if (language === LOCALE_ES_MX || language === LANGUAGE_SPANISH) return LANGUAGE_SPANISH;

  // Handle legacy 'pt-BR' or new 'pt'
  if (language === LOCALE_PT_BR || language === LANGUAGE_PORTUGUESE) return LANGUAGE_PORTUGUESE;

  // Default fallback for any unexpected values
  return LANGUAGE_ENGLISH;
};

export default (state: CurrentLanguageState = initialState, action: RootAction): CurrentLanguageState => {
  switch (action.type) {
    case getType(setCurrentLanguage): {
      return sanitizeLanguage(action.payload);
    }
    default: {
      return state;
    }
  }
};